

var temp_compare_products=localStorage.getItem('compareList');
if(temp_compare_products != undefined || temp_compare_products != null){
  compare_products=JSON.parse(temp_compare_products);;
  if(compare_products.length){
      document.querySelector('[data-compare_page_btn]').classList.add('show');
      document.querySelector('[data-compare_item_length]').innerHTML=`(${compare_products.length})`;
  }else{
      document.querySelector('[data-compare_page_btn]').classList.remove('show')
  }
}
if (document.querySelector('[data-compare_products]') != null) {
    _prepareCompareHtml();
}
// function _prepareCompareHtml(){
//     if (compare_products != null && compare_products.length > 0) {
//         var products_html="";
//         var allKeys=['sku','description'];
//         for (var item of compare_products) {
//             if (item.metafields != null ) {
//                 for (var key in item.metafields) {
//                     allKeys.push(key);
//                 }
//             }
//         }
//         allKeys=allKeys.filter((item, 
//             index) => allKeys.indexOf(item) === index);
//         var keyHtml="";
//         for (var key of allKeys) {
//             let tempHtml=`
//                 <th class="text-uppercase small">${key.replaceAll('_',' ')}</th>
//             `;
//             keyHtml+=tempHtml;
//         }
//         document.querySelector('[data-compare-keys]').innerHTML=keyHtml;
//         for (var item of compare_products) {
//             product=item.product;
//             metafields=item.metafields;
//             var metafieldHtml="";
//             for (var key of allKeys) {
//                 let html=``;
//                 if (key == 'sku') {
//                     html=`<td>
//                         <p class="text-gray-600 mb-0">${product.variants[0].sku != ""  ? product.variants[0].sku: '- - -' }</p>
//                     </td>`;
//                 }else if(key == 'description'){
//                     html=`<td>
//                             <p class="text-gray-600 mb-0">${product.description != "" ? product.description: '- - -' }</p>
//                         </td>
//                     `;
//                 }else{
//                     value=metafields[key] || '';
//                     html=`<td>
//                             <p class="text-gray-600 mb-0">${value != "" ? value : '- - -' }</p>
//                         </td>
//                     `
//                 }
//                 metafieldHtml+=html
//             }
//             let tempHtml=`
//             <tr class="d-flex flex-column">
//                 <td>
//                     <div class="card">
//                         <div class="card-img">
//                             <img src="${product.featured_image}" style="height:100px;width:100px" alt="product-title" srcset="">    
//                         </div>
//                         <div class="card-body">
//                             <h5 class="text-gray-600">${product.title}</h5>
//                         </div>
//                         <div class="card-footer card-product">
//                             <a class="btn btn-primary" href="javascript:void(0)" data-handle="${product.handle}" data-quick_view><h6 class="text-uppercase text-white lh-base mb-0 ls-md">quick view</h6></a>
//                             <a href="javascript:void(0);" class="text-secondary" data-remove_compare_product="${product.id}">Remove</a>
//                         </div>
//                     </div>                  
//                 </td>
//                 ${metafieldHtml}
//             </tr>
//             `;
//             products_html+=tempHtml;
//         }    
//         document.querySelector('[data-compare_products]').innerHTML=products_html;
//         document.querySelector('[data-empty_compare]').classList.add('d-none');
//         document.querySelector('[data-compare_page]').classList.remove('d-none');
//         document.querySelectorAll('[data-quick_view]').forEach(ele => {
//             ele.addEventListener('click',(event)=>{
//                 event.stopImmediatePropagation();
//                 let handle=ele.getAttribute('data-handle');
//                 document.querySelector('[data-compare_page_quick_view]').setAttribute('data-handle',handle);
//                 document.querySelector('[data-compare_page_quick_view]').click();
//             })
//         });
//         document.querySelectorAll('[data-remove_compare_product]').forEach(ele => {
//             ele.addEventListener('click',(event)=>{
//                 let product_id=parseInt(ele.getAttribute('data-remove_compare_product'))
//                 for (var [index,item] of compare_products.entries()) {
//                     if (item.product.id == product_id) {
//                       compare_products.splice(index, 1);
//                       localStorage.setItem('compareList',JSON.stringify(compare_products));
//                       _prepareCompareHtml();
//                     }
//                 }
//             })
//         });
        
//     }else{
//         document.querySelector('[data-compare_page]').innerHTML="";
//         document.querySelector('[data-empty_compare]').classList.remove('d-none');
//         document.querySelector('[data-compare_page]').classList.add('d-none');
//     }
// }

function _prepareCompareHtml(){
    if (compare_products != null && compare_products.length > 0) {
        var products_html="";
        var allkeys=['','sku','description'];
        for (var item of compare_products) {
            if (item.product.tags.length > 0) {
                for (var tag of item.product.tags) {
                    if (tag.includes('comp_')) {
                        tag=tag.split('_')
                        allkeys.push(`comp_${tag[1]}`);
                    }
                }                
            }
            if (item.metafields != null ) {
                for (var key in item.metafields) {
                    allkeys.push(key);
                }
            }
            
        }
        allkeys=allkeys.filter((item, 
            index) => allkeys.indexOf(item) === index);

        for (var [i,key] of allkeys.entries()) {
            var itemsHtml="";
            for (const item of compare_products) {
                var product=item.product;
                var tags=item.product.tags;
                var metafields=item.metafields;
                let tempItemHtml=``;
                if (i == 0) {
                    tempItemHtml=`
                        <div class="col-sm-6 col-10 compare-product-detail">
                            <div class="card">
                                <div class="card-img">
                                    <img src="${product.featured_image}"  alt="${product.title}">
                                    <a href="javascript:void(0);" data-remove_compare_product="${product.id}" class="remove-icon"><i class="prosoccer-close"></i></a>    
                                </div>
                                <div class="card-body">
                                    <h5 class="product-title">${product.title}</h5>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-outline-dark btn-sm ctn-btn" data-handle="${product.handle}" data-quick_view>Quick View</button>
                                </div>
                            </div> 
                        </div>
                    `;
                    
                }else if(i == 1){
                    tempItemHtml=`
                        <div class="col-sm-6 col-10 compare-product-detail">
                            <p>${product.variants[0].sku != ""  ? product.variants[0].sku: '- - -' }</p>
                        </div>
                    `;
                }else if(i == 2){
                    tempItemHtml=`
                        <div class="col-sm-6 col-10 compare-product-detail">
                            <p>${product.description != "" ? product.description: '- - -' }</p>
                        </div>
                    `;
                }else if(key.includes('comp_')){
                    var tag="";
                    for (let t of tags) {
                        if (t.includes(key) ) {
                            tag=t.split('_')[2];
                        }
                    }
                    
                    tempItemHtml=`
                        <div class="col-sm-6 col-10 compare-product-detail">
                            <p class="text-capitalize">${tag != "" ? tag : '- - -' }</p>
                        </div>
                    `;
                }
                else{
                    value=metafields[key] || '';
                    if(!JSON.stringify(metafields[key]).includes('json not allowed for this object') ){
                    tempItemHtml=`
                        <div class="col-sm-6 col-10 compare-product-detail">
                            <p>${value != "" ? value: '- - -' }</p>
                        </div>
                    `;  
                    }
                    
                }
                itemsHtml+=tempItemHtml;
            }
          if(itemsHtml != ''){
            let tempHtml=`
            <div class="row no-gutter">
            <div class="col-sm-2 col-4 sidebar-sticky">
                ${key.includes('comp_') ? key.replaceAll('comp_', '').split('_')[0] : key.replaceAll('_', ' ')}
            </div>
                <div class="col-sm-10 col-8 d-flex compare-product-details-wrapper">
                    ${itemsHtml}
                </div>
            </div>
            `;
            products_html+=tempHtml;
            
          }
            
        }
        document.querySelector('[data-compare_products]').innerHTML=products_html;
        document.querySelector('[data-empty_compare]').classList.add('d-none');
        document.querySelector('[data-empty_compare]').classList.remove('d-flex');
        document.querySelector('[data-compare_page]').classList.remove('d-none');
        document.querySelectorAll('[data-quick_view]').forEach(ele => {
            ele.addEventListener('click',(event)=>{
                event.stopImmediatePropagation();
                let handle=ele.getAttribute('data-handle');
                document.querySelector('[data-compare_page_quick_view]').setAttribute('data-handle',handle);
                document.querySelector('[data-compare_page_quick_view]').click();
            })
        });
        document.querySelectorAll('[data-remove_compare_product]').forEach(ele => {
            ele.addEventListener('click',(event)=>{
                let product_id=parseInt(ele.getAttribute('data-remove_compare_product'))
                for (var [index,item] of compare_products.entries()) {
                    if (item.product.id == product_id) {
                      compare_products.splice(index, 1);
                      localStorage.setItem('compareList',JSON.stringify(compare_products));
                      _prepareCompareHtml();
                    }
                }
            })
        });
    }else{
        document.querySelector('[data-compare_page]').innerHTML="";
        document.querySelector('[data-empty_compare]').classList.remove('d-none');
        document.querySelector('[data-empty_compare]').classList.add('d-flex');
        document.querySelector('[data-compare_page]').classList.add('d-none');
        if(compare_products.length){
            document.querySelector('[data-compare_page_btn]').classList.add('show');
            document.querySelector('[data-compare_item_length]').innerHTML=`(${compare_products.length})`;
        }else{
            document.querySelector('[data-compare_page_btn]').classList.remove('show');
        }
    }
}
